import { Subject } from 'rxjs';
import { KeyValuePair } from './../model/RenewPlan';
import { Injectable } from '@angular/core';
import { RenewPlanModel } from '../model/RenewPlan';
import { ProductResult}  from "../model/Product";
import { UserDetailResult } from '../model/UserDetail';
import { LteActiveSession } from '../model/LteActiveSessions';
import { BnNgIdleService } from 'bn-ng-idle';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})


export class SharedService {

  activeSessions : LteActiveSession[];
  userdetail:UserDetailResult;
  filteredSelfcareProducts : ProductResult[] = {} as ProductResult[];
  RenewPlanObject: RenewPlanModel = {} as RenewPlanModel;
  subject : Subject<Object> = new Subject<object>();
  CustomerBalance : number = 0;


  constructor(private bnIdle: BnNgIdleService, private toastr : ToastrService, private authenticationService : AuthenticationService) {
    
  }


  watchingUserActivity(){

    this.bnIdle.startWatching(600).subscribe((isTimedOut: boolean) => {

      
      if (isTimedOut) {

        this.authenticationService.logout();        
        this.bnIdle.stopTimer();
        //this.router.navigate(['/']);
        return;

      }
      
    });
    
  }


  
  getPeriod () : KeyValuePair[]{
    return [
      {value: 1,text: "1 month" },
      {value: 2,text: "2 months" },
      {value: 3,text: "3 months" },
      {value: 4,text: "4 months" },
      {value: 5,text: "5 months" },
      {value: 6,text: "6 months" },
      {value: 7,text: "7 months" },
      {value: 8,text: "8 months" },
      {value: 9,text: "9 months" },
      {value: 10,text: "10 months" },
      {value: 11,text: "11 months" },
      {value: 12,text: "12 months" },
      {value: 13,text: "13 months" },
      {value: 14,text: "14 months" },
      {value: 15,text: "15 months" },
      {value: 16,text: "16 months" },      
      {value: 17,text: "17 months" },
      {value: 18,text: "18 months" },
      {value: 19,text: "19 months" },
      {value: 20,text: "20 months" },
      {value: 21,text: "21 months" },
      {value: 22,text: "22 months" },
      {value: 23,text: "23 months" },
      {value: 24,text: "24 months" },
    ]
  }

  getSupportOptions () {
    return [
      {value: 1,label: "Complaint" },
      {value: 2,label: "Enquiry" },
      {value: 3,label: "General Comment" },
      {value: 4,label: "Report Issue" },
      {value: 5,label: "Technical Support" },
     
    ]
  }





}


